import axios from 'axios';
import { EncounterRxReconcile } from '../models/encounter-rx-reconcile';

export const getEncounterRxReconciles = async (ids: number[]): Promise<Undefinable<EncounterRxReconcile[]>> => {
    const response = await axios.post(`/api/encounter-rx-reconcile`, ids);
    return response.data;
};
